import { render, staticRenderFns } from "./TakipSorguAlanlariPicker.vue?vue&type=template&id=f2f23bb4&scoped=true"
import script from "./TakipSorguAlanlariPicker.vue?vue&type=script&lang=ts"
export * from "./TakipSorguAlanlariPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f23bb4",
  null
  
)

export default component.exports